import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';

const data = [
  {
    name: 'GFP',
    fluorescence: 158709,
  },
  {
    name: 'GFP+PK',
    fluorescence: 156466,
  },
];

function Figure3() {
  return (
    <div>
      <br></br>
      <u>Figure 3: Measure of GFP fluorescence after digestion by Proteinase K (PK)
      </u>
      
      <BarChart width={600} height={300} data={data} margin={{ top: 20, right: 30, left: 20, bottom: 10 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Bar dataKey="fluorescence" fill="#e29aff" label={{ position: 'top' }}/>
      </BarChart>
    </div>
  );
}

export default Figure3;
